
import React, { Component } from 'react';
import { UserContext } from '.';
import styled, { css } from 'styled-components';
import {
  Popover,
  IconButton
} from '@material-ui/core';
import { grey } from "@material-ui/core/colors";
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ToolbarSwitchDepartment from "./ToolbarSwitchDepartment";
import {SequenceDisplay} from "../../core/Display";
import { useNavbarCollapsed } from 'components/Dashboard/State';

const Wrapper = styled.div`
  display: grid;
  height: 100%;
  align-items: flex-end;
  padding-bottom: 15px;
`;

const StyledAccountToolbar = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr 26px;
  grid-gap: 11px;
  text-align: left;
  padding: 0 11px;
  align-items: center;

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${props => props.$collapsed && css`
    grid-template-columns: auto;
    justify-content: center;
    padding: 0;
    text-align: center;

    .name {
      display: none;
    }
  `}
`;

const StyledIconButton = styled(IconButton)`
  width: 36px;
  height: 36px;
  background: #E0E0E0 !important;
`;

const StyledPopoverContent = styled.div`
  padding: 10px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto 1fr;
  font-size: 14px;
  
  label {
    text-align: right;
    color: ${grey[500]};
  }
  
  span {
    color: ${grey[700]};
  }
`;


class UserToolbarInner extends Component {

  constructor(props) {
    super(props);

    this.anchorEl = React.createRef();

    this.state = {
      isPopoverOpen: false
    }
  }

  togglePopover = () => {
    this.setState({
      isPopoverOpen: !this.state.isPopoverOpen
    })
  }

  render() {
    const { isPopoverOpen } = this.state;
    const { navbarCollapsed } = this.props;

    return(
      <UserContext.Consumer>
        {context => {
          const { data, actions } = context;
          return (
            <Wrapper className={'UserToolbar-Wrapper'}>
              <StyledAccountToolbar className={'UserToolbar-AccountToolbar'} $collapsed={navbarCollapsed}>
                <div>
                  <StyledIconButton
                    ref={this.anchorEl}
                    onClick={() => this.togglePopover()}
                  >
                    <PersonOutlineOutlinedIcon style={{
                      color: '#828282'
                    }} />
                  </StyledIconButton>
                  <Popover
                    anchorEl={() => this.anchorEl.current}
                    onClose={() => this.togglePopover()}
                    open={isPopoverOpen}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    <StyledPopoverContent>
                      <label>Имя пользователя:</label>
                      <span>{data.username || '-'}</span>

                      <label>Email:</label>
                      <span>{data.email || '-'}</span>

                      <label>ФИО:</label>
                      <span>
                        <SequenceDisplay
                            values={[data.last_name, data.first_name, data.middle_name]}
                            separator={' '}
                        />
                      </span>

                      <label>Времення зона:</label>
                      <span>{data.timezone}</span>
                    </StyledPopoverContent>
                  </Popover>
                </div>
                <div className={'name'}>
                  {data.departments && (
                    <ToolbarSwitchDepartment />
                  )}
                </div>
                <div>
                  <IconButton size="small" onClick={actions.logOut} title={'Выход'}>
                    <ExitToAppIcon fontSize="small" />
                  </IconButton>
                </div>
              </StyledAccountToolbar>
            </Wrapper>
          )
        }}
      </UserContext.Consumer>
    )
  }
}

export function UserToolbar() {
  const { navbarCollapsed } = useNavbarCollapsed();
  return <UserToolbarInner navbarCollapsed={navbarCollapsed} />;
}
